export const PRICE = "OMR";
// export const GOOGLE_MAP_KEY = "AIzaSyAkFh9twd_1jlQ-nvyzHtD4avi_VWuwFVw";
export const GOOGLE_MAP_KEY = "twd_1jlQ-nvyzHtD4avi_VWuwFVw";

export const FIREBASECONFIG = {
  apiKey: "AIzaSyAa0BgSgqhWFxhaA1yrzFWubqG3h60nB3Y",
  authDomain: "wegramsocial-65c32.firebaseapp.com",
  databaseURL: "https://wegramsocial-65c32-default-rtdb.firebaseio.com",
  projectId: "wegramsocial-65c32",
  storageBucket: "wegramsocial-65c32.firebasestorage.app",
  messagingSenderId: "611439658426",
  appId: "1:611439658426:web:40b65b5c009f1567588983",
  measurementId: "G-285FDPBHLB",
};

export const OTPMessage = "Enter OTP that has been sent to your mobile number.";

export const bannerType = [
  { id: "normal", value: "Normal" },
  { id: "category", value: "Category" },
];

export const PAYMENT_TYPE = [
  { id: "cod", value: "COD" },
  { id: "online", value: "Online" },
  // {id : 'card', value : "Card"},
  // {id : 'upi', value : "UPI"},
];

export const NOTIFICATION_TYPE = {
  DRIVER_ALERT: "DriverAlert",
  USER: "User",
  ORDER: "Order",
};

/* export const ORDER_STATUS = {
    new                 :   "New",
    pending             :   "Pending",
    confirmed           :   "Accepted",
    packaged            :   "Ready",
    out_for_delivery    :   "out_for_delivery",
    on_the_way          :   "InDelivery",
    delivered           :   "Completed",
    cancelled           :   "Declined",
}; */

export const ORDER_STATUS = {
  NEW: "New", // When Order Placed By The Customer
  ACCEPTED: "Accepted", // Accepted The Order By Restaurant
  CONFIRMED: "Confirmed", // Confirmed By Driver To Deliver This Order
  REJECTED: "Rejected", // Rejected By Driver
  PREPARING: "Preparing", // When Order Preparing
  READY: "Ready_to_Pickup", // When Restaurant Prepared The Order & It's Ready For Deliver By Driver
  PICKEDUP: "Picked_Up", // When Order is Picked Up From Restaurant
  IN_DELIVERY: "In_Delivery", // When order is in delivery mode
  OUT_FOR_DELIVERY: "Out_for_Delivery", //  When Driver Take The Order & Go to Delivery
  COMPLETED: "Completed", // Order is Completed By Driver
  DECLINED: "Declined", // Declined By Restaurant
  CANCEL_PICKUP: "Cancel_Pickup", // Driver Side Status
  CANCEL_DELIVERY: "Cancel_Delivery", // Driver Side Status
  CANCEL: "Cancel", // Cancel By Customer
};

export const MAXPRODUCTLIMITTYPE = [
  { value: "limited", name: "Limited" },
  { value: "unlimited", name: "Unlimited" },
];

export const USERTYPE = {
  USER: "USER",
  SUPER_ADMIN: "SUPER_ADMIN",
  MODERATOR: "MODERATOR",
  CONTENT_MANAGER: "CONTENT_MANAGER",
};

export const DRIVER_TYPE = [
  { value: "payroll", name: "Payroll" },
  { value: "third_party", name: "3rd Party" },
];

export const SUBSCRIPTIONOFFEREDTYPE = [
  { value: "client_location", name: "Client Location" },
  { value: "vendor_location", name: "Vendor Location" },
  { value: "both", name: "Both" },
];

export const CricketRole = {
  BATSMAN: "batsman",
  BOWLER: "bowler",
  ALL_ROUNDER: "all_rounder",
  WICKET_KEEPER: "wicket_keeper",
};

export const UserStatus = {
  ACTIVE: "active",
  SUSPENDED: "suspended",
  BANNED: "banned",
};

export const MODULE_KEYS = [
  // "DASHBOARD",
  // "ADMIN_ROLE_PERMISSION",
  // "ADMIN_ACCOUNT_MANAGEMENT",
  // "ROLE_MANAGER",
  // "REPORT_MANAGER",
  // "CATEGORY_MANAGER",
  // "EMAIL_TEMPLATE_MANAGER",
  // "NOTIFICATION_MANAGER",
  // "POINTS_LEVELS_MANAGER",
  "USER_MANAGER",
  "POST_MANAGER",
  "TAG_MANAGER",
  "REWARDS_MANAGER",
  "CONTENT_MANAGER",
  "ADVERTISEMENTS_MANAGER",
];

export const COMMON_MODULE_KEYS = [
  "DASHBOARD",
  "ROLE_MANAGER",
  "REPORT_MANAGER",
  "CATEGORY_MANAGER",
  "USER_MANAGER",
  "COACH_ACADEMY_MANAGEMENT",
  "EMAIL_TEMPLATE_MANAGER",
  "NOTIFICATION_MANAGER",
  "POINTS_LEVELS_MANAGER",
  "LEADERBOARD_MANAGER",
  "TOURNAMENT_MANAGER",
  "MUSIC_MANAGER",
];

// Permission based modules
export const PERMISSION_MODULE_KEYS = [
  "POST_MANAGER",
  "GROUP_MANAGER",
  "TAG_MANAGER",
  "REWARDS_MANAGER",
  // "CONTENT_MANAGER",
  // "ADVERTISEMENTS_MANAGER",
];
